import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import {NumericFormat} from 'react-number-format';
import {InputProps} from '../../models/FormInputs';
import {useEnabledInputFieldStyles} from './styles';

type QuoteFormTextFieldProps = TextFieldProps &
  InputProps & {inputProps?: InputBaseComponentProps; adornment?: 'money' | 'percentage'};

export const QuoteTextFieldInput = (props: QuoteFormTextFieldProps) => {
  const classes = useEnabledInputFieldStyles();
  const {label, inputFieldProps, error, helperText, className, inputProps, ...otherProps} = props;

  return (
    <TextField
      variant="outlined"
      InputProps={{
        style: inputFieldProps?.style,
        startAdornment: inputFieldProps?.startAdornment ? (
          <InputAdornment position="start">{inputFieldProps?.startAdornment}</InputAdornment>
        ) : null,
        endAdornment: inputFieldProps?.endAdornment ? (
          <InputAdornment position="end">{inputFieldProps?.endAdornment}</InputAdornment>
        ) : null,
      }}
      inputProps={{
        ...inputProps,
        style: {
          borderRadius: 0,
          backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
          color: props.disabled ? '#474747' : '#000',
        },
      }}
      fullWidth
      margin="dense"
      title={(otherProps?.value as string) ?? ''}
      disabled={props.disabled}
      className={classNames(className, {[classes.root]: otherProps.disabled === false})}
      error={error}
      style={{
        borderRadius: 0,
        backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
        color: props.disabled ? '#474747' : '#000',
      }}
      {...otherProps}
    />
  );
};

export const MoneyInputAdornment = () => <InputAdornment position="start">$</InputAdornment>;
export const PercentageInputAdornment = () => <InputAdornment position="end">%</InputAdornment>;

export const QuoteTextField = (props: QuoteFormTextFieldProps) => {
  const classes = useEnabledInputFieldStyles();
  const {label, inputFieldProps, error, helperText, className, inputProps, ...otherProps} = props;

  if (props.type === 'number') {
    return (
      <FormControl fullWidth error={error}>
        <NumericFormat
          id={props.id}
          customInput={QuoteTextFieldInput}
          value={props.value as number}
          onValueChange={values =>
            props.onChange?.({
              target: {
                name: props.name,
                value: Number(values.value) as any,
              },
            } as React.ChangeEvent<HTMLInputElement>)
          }
          prefix={props.adornment === 'money' ? '$' : undefined}
          suffix={props.adornment === 'percentage' ? '%' : undefined}
          thousandSeparator
          allowNegative={false}
          error={error}
          helperText={helperText}
          inputProps={inputProps}
          fullWidth
          margin="dense"
          title={(otherProps?.value as string) ?? ''}
          disabled={props.disabled}
          className={classNames(className, {[classes.root]: otherProps.disabled === false})}
          style={{
            borderRadius: 0,
            backgroundColor: props.disabled ? '#E8E8E8' : 'transparent',
            color: props.disabled ? '#474747' : '#000',
          }}
          onBlur={props.onBlur}
        />
        <FormHelperText>{helperText ?? ''}</FormHelperText>
      </FormControl>
    );
  }
  return (
    <FormControl fullWidth error={error}>
      <QuoteTextFieldInput {...props} />
      <FormHelperText>{helperText ?? ''}</FormHelperText>
    </FormControl>
  );
};
